import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { IDisputeResponseById } from '../types/DisputeTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const DisputesApi = createApi({
  reducerPath: 'DisputesApi',
  tagTypes: ['Disputes'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (builder) => ({
    getDisputeById: builder.query<IDisputeResponseById, string>({
      query: (orderId: string) => ({
        url: `disputes/get_disputes_by_order/${orderId}`,
        method: 'GET',
      }),
      providesTags: ['Disputes'],
    }),
    postDispute: builder.mutation<any, any>({
      query: (body) => ({
        url: `disputes/`,
        method: 'POST',
        body,
        headers: {},
      }),
    }),
  }),
});

export const { useGetDisputeByIdQuery, usePostDisputeMutation } = DisputesApi;
